{
  "fr": {
    "task_assignment": {
      "actions": {
        "add_assignee": "Ajouter une personne assignée",
        "bulk_remove": "Retirer de la tâche",
        "change_status": "Modifier le statut",
        "confirm": "Marquer comme terminé",
        "create": "Tâche",
        "delete": "Supprimer la personne assignée",
        "due_in_month": "Dans un mois",
        "due_in_two_weeks": "Dans deux semaines",
        "due_in_week": "Dans une semaine",
        "due_remove": "Supprimer l'échéance",
        "move_to_draft": "Remettre en brouillon",
        "reopen": "Rouvrir",
        "selectAll": "Tout sélectionner ({total})",
        "send_and_notify": "Envoyer et notifier",
        "set_due_date": "Définir l'échéance",
        "set_status": "Définir le statut",
        "unSelectAll": "Désélectionner tout"
      },
      "assignee_types": {
        "customer": "Client",
        "employee": "Employé",
        "partner": "Partenaire"
      },
      "attributes": {
        "assignee": "Personne assignée",
        "assignees": "Personnes assignées",
        "comment": "Commentaire",
        "created_at": "Créé",
        "document": "Document",
        "due_date": "Échéance",
        "project": "Projet",
        "status": "Statut",
        "task": "Tâche",
        "unit": "Unité"
      },
      "confirm": {
        "affected": "Cela concerne {customers} et {team}.",
        "affected_customers": "Cela concerne {customers}.",
        "affected_team": "Cela concerne {team}.",
        "bulk_affected": "Ceci écrit {count} tâche. | Ceci écrit {count} tâches.",
        "bulk_delete_body": "La tâche reste, sur cette unité comme sur les autres. Seules les lignes sélectionnées disparaissent.",
        "bulk_delete_header": "Retirer ces tâches ?",
        "complete_body": "Leurs tâches sont clôturées pour eux et disparaissent de leur liste, même s'ils n'ont rien fait.",
        "complete_header": "Clôturer cette tâche pour tout le monde ?",
        "customer_tasks": "{count} tâche client | {count} tâches client",
        "delete_body": "Seule cette attribution disparaît. La tâche garde ses autres personnes assignées et ses autres unités.",
        "delete_header": "Supprimer {name} de cette tâche ?",
        "delete_sent_customers": "Celle-ci a déjà été envoyée, elle disparaît donc aussi du portail client de {unit}.",
        "delete_sent_team": "Celle-ci a déjà été envoyée, elle disparaît donc aussi de la liste de {name}.",
        "draft_body": "La tâche disparaît jusqu'à ce qu'elle soit renvoyée. Les e-mails déjà partis restent envoyés.",
        "draft_header": "Remettre cette tâche en brouillon ?",
        "send_customers": "Les clients voient la tâche tout de suite dans leur portail et reçoivent une notification.",
        "send_header": "Envoyer aux destinataires ?",
        "send_permanent": "L'envoi est définitif. Remettre la tâche en brouillon plus tard n'annule pas la notification.",
        "send_status": "Elles passent à Demandé.",
        "send_team": "Les membres de l'équipe sont prévenus.",
        "team_tasks": "{count} tâche d'équipe | {count} tâches d'équipe"
      },
      "filters": {
        "due_window_values": {
          "month": "Échéance dans le mois",
          "none": "Pas d'échéance",
          "overdue": "En retard",
          "week": "Échéance dans la semaine"
        },
        "show_only": "Afficher uniquement",
        "show_only_values": {
          "customers": "Clients",
          "mine": "Qui me sont assignées",
          "team": "Équipe"
        }
      },
      "labels": {
        "add_assignee": "Ajouter une personne assignée…",
        "add_customers": "Ajouter des clients",
        "already_assigned": "Cette tâche est déjà ajoutée à cette unité.",
        "already_assigned_project": "Cette tâche est déjà ajoutée à ce projet.",
        "assignees": "Personnes assignées",
        "comment_earlier": "+{count} plus tôt",
        "comment_earlier_round": "tour précédent",
        "comment_placeholder": "p. ex. le compteur était difficile d'accès, voici la meilleure photo possible",
        "comments_none": "Le client n'a laissé aucun commentaire.",
        "comments_title": "Commentaires sur cette tâche",
        "completed": "Terminées",
        "confirm_message": "Voulez-vous vraiment marquer cette tâche comme terminée ?",
        "customers": "Clients",
        "my_tasks": "Mes tâches",
        "no_assignees": "Aucune personne assignée pour le moment.",
        "no_assignments": "Aucune tâche pour le moment.",
        "no_assignments_task": "Aucune assignation pour cette tâche pour le moment.",
        "no_assignments_unit": "Aucune tâche pour cette unité pour le moment.",
        "required": "Ce champ est obligatoire",
        "selectOne": "Sélectionnez au moins une tâche.",
        "select_task": "Sélectionner une tâche",
        "selected": "{selected} sélectionnée | {selected} sélectionnées",
        "set_status_for": "Définir le statut de {name}",
        "totalSelected": "Les {total} sélectionnées",
        "upload_hint": "Téléversez le ou les documents demandés pour terminer cette tâche.",
        "uploaded_documents": "Documents téléversés"
      },
      "statuses": {
        "completed": "Terminé",
        "draft": "Brouillon",
        "requested": "Demandé"
      },
      "toasts": {
        "bulk_delete": "Tâches retirées",
        "bulk_update": "Tâches mises à jour",
        "completed": "Tâche terminée",
        "create": "Tâche créée",
        "delete": "Personne assignée supprimée",
        "reopened": "Tâche rouverte",
        "update": "Tâche mise à jour"
      }
    }
  }
}
